export default "__VITE_ASSET__CdSK4NdE__"